export default __webpack_public_path__ + "06d3550255a05b7b694a01834c25395a.png";